


export const SINGLE_GET_REQUEST = "SINGLE_GET_REQUEST"
export const SINGLE_GET_SUCCESS = "SINGLE_GET_SUCCESS"
export const SINGLE_GET_FAILURE = "SINGLE_GET_FAILURE"
